import { render, staticRenderFns } from "./TabOrganization.vue?vue&type=template&id=5867c2c1"
import script from "./TabOrganization.vue?vue&type=script&lang=js"
export * from "./TabOrganization.vue?vue&type=script&lang=js"
import style0 from "./TabOrganization.vue?vue&type=style&index=0&id=5867c2c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports